export enum Allergen {
	CerealsContainingGluten = "CerealsContainingGluten",
	CerealsContainingGlutenWheat = "CerealsContainingGlutenWheat",
	CerealsContainingGlutenRye = "CerealsContainingGlutenRye",
	CerealsContainingGlutenBarley = "CerealsContainingGlutenBarley",
	CerealsContainingGlutenOats = "CerealsContainingGlutenOats",
	CerealsContainingGlutenSpelt = "CerealsContainingGlutenSpelt",
	CerealsContainingGlutenKamut = "CerealsContainingGlutenKamut",
	Crustaceans = "Crustaceans",
	Egg = "Egg",
	Fish = "Fish",
	Peanut = "Peanut",
	Soybeans = "Soybeans",
	Milk = "Milk",
	Nuts = "Nuts",
	NutsAlmond = "NutsAlmond",
	NutsHazelnut = "NutsHazelnut",
	NutsWalnut = "NutsWalnut",
	NutsCashew = "NutsCashew",
	NutsPecan = "NutsPecan",
	NutsBrazilNut = "NutsBrazilNut",
	NutsPistachios = "NutsPistachios",
	NutsMacadamia = "NutsMacadamia",
	Celery = "Celery",
	Mustard = "Mustard",
	Sesame = "Sesame",
	SulphurDioxideAndSulphurites = "SulphurDioxideAndSulphurites",
	Lupin = "Lupin",
	Molluscs = "Molluscs",
}
